<template>
    <v-line
            :config="lineConfig"
            @mouseover="hover(true)"
            @mouseout="hover(false)"
            @dblclick="flip"
    ></v-line>
</template>

<script>
    import { mapState, mapGetters, mapMutations } from 'vuex';

    export default {
        name: "LineFold",

        props: [
            'id',
            'fromPoint',
            'toPoint',
            'lineColor',
            'lineColorHover',
        ],

        data() {
            return {
                isHovered: false,
            }
        },

        computed: {
            ...mapState('editor', [
                'points',
            ]),

            ...mapGetters('editor', [
                'getPointIndexById',
                'trimEditDisabled',
            ]),

            color() {
                return this.isHovered ? this.lineColorHover : this.lineColor;
            },

            lineConfig() {
                let xFrom = this.fromPoint.x;
                let yFrom = this.fromPoint.y;
                let xTo = this.toPoint.x;
                let yTo = this.toPoint.y;

                let points = [xFrom, yFrom, xTo, yTo];

                return {
                    name: 'Fold',
                    points,
                    stroke: this.color,
                    strokeWidth: 3,
                    hitStrokeWidth: 21,
                    lineCap: 'round',
                    lineJoin: 'round',
                }
            },

        },

        methods: {
            ...mapMutations('editor', [
                'setPoints',
            ]),

            mirror(p,[p1, p2]) {
                let [vx,vy]= [ p2[0]-p1[0], p2[1]-p1[1] ];
                let [x,y]  = [ p1[0]-p[0], p1[1]-p[1] ];
                let r= 1/(vx*vx+vy*vy);
                return [ p[0] +2*(x -x*vx*vx*r -y*vx*vy*r),
                    p[1] +2*(y -y*vy*vy*r -x*vx*vy*r)  ];
            },

            flip() {
                if (this.trimEditDisabled) return;

                // get the direction of the fold line
                let isFoldStart = this.fromPoint['isFoldStart'];

                // get the point of the fold line to flip around it
                let flipAroundPoint = isFoldStart ? this.fromPoint : this.toPoint;

                // index of the point around which the flip occurs
                let flipAroundPointIndex = this.getPointIndexById(flipAroundPoint.id);

                // take the previous point to make a mirror around this line
                let flipAroundPrevPointIndex = flipAroundPoint.type === 'fold' ? flipAroundPointIndex - 1 : flipAroundPointIndex + 1;

                let flipAroundPrevPoint = this.points[flipAroundPrevPointIndex];

                // line for the mirror
                let lineP1 = [flipAroundPoint.x, flipAroundPoint.y];
                let lineP2 = [flipAroundPrevPoint.x, flipAroundPrevPoint.y];

                let newPoints = [];

                this.points.forEach((point, i) => {

                    // mirror only those points that follow the flipAroundPoint and in the correct direction
                    if ( (isFoldStart && i > flipAroundPointIndex) || (!isFoldStart && i < flipAroundPointIndex) ) {

                        let p = [point.x, point.y];
                        let newPos = this.mirror(p, [lineP1, lineP2]);

                        point.x = newPos[0];
                        point.y = newPos[1];
                    }

                    newPoints.push(point);
                });

                this.setPoints(newPoints);
            },

            hover(state) {
                this.isHovered = !!state;
            },

        },

    }
</script>

<style>

</style>